import { Control, useForm, UseFormHandleSubmit, UseFormReturn } from "react-hook-form";

import { CaseSummary } from "src/types/case";
import { Rule } from "src/types/rule";

export type ExecutionParametersFormControl = {
  control: Control<ExecutionParametersFormData>;
  submit: UseFormHandleSubmit<ExecutionParametersFormData>;
  hasError: boolean;
  methods: UseFormReturn<ExecutionParametersFormData>;
};

export type ExecutionParametersFormData = {
  rule?: Rule;
  caseItem?: CaseSummary;
};

export const useExecutionParametersForm = (
  selectedCase?: CaseSummary
): ExecutionParametersFormControl => {
  const methods = useForm<ExecutionParametersFormData>({
    defaultValues: {
      rule: undefined,
      caseItem: selectedCase,
    },
  });

  const rule = methods.watch("rule");
  const caseItem = methods.watch("caseItem");
  const { isSubmitted } = methods.formState;
  const hasError = isSubmitted ? !rule || !caseItem : false;

  return {
    control: methods.control,
    submit: methods.handleSubmit,
    hasError,
    methods,
  };
};
